import { io, Socket } from "socket.io-client";

const SOCKET_URL = import.meta.env.VITE_APP_SOCKET_URL;

let socket: Socket | null = null;

const HEARTBEAT_INTERVAL = 15000;
let heartbeatInterval: NodeJS.Timeout | null = null;

const connectSocket = (userId: string): Socket => {
  if (socket && socket.connected) return socket;

  socket = io(SOCKET_URL as string, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    withCredentials: true,
    query: { userId },
  });

  socket.on("connect", () => {
    console.log("✅ Socket connected:", socket?.id);

    // Start heartbeat ping
    if (heartbeatInterval) clearInterval(heartbeatInterval);
    heartbeatInterval = setInterval(() => {
      if (socket?.connected) {
        socket.emit("ping");
      }
    }, HEARTBEAT_INTERVAL);
  });

  socket.on("disconnect", (reason) => {
    console.warn("⚠️ Socket disconnected:", reason);
    if (heartbeatInterval) clearInterval(heartbeatInterval);
  });

  socket.io.on("reconnect", (attempt) => {
    console.log("🔁 Socket reconnected after", attempt, "attempt(s)");
  });

  socket.on("connect_error", (err) => {
    console.error("❌ Socket connection error:", err.message);
  });

  socket.on("pong", () => {
    console.log("📡 Heartbeat pong received");
  });

  return socket;
};

const disconnectSocket = () => {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }

  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
};

const getSocket = (userId: string): Socket => {
  if (!socket || !socket.connected) {
    return connectSocket(userId);
  }
  return socket;
};

export { getSocket, disconnectSocket };
